$('.share-box .share-link').on('click', function () {
   $(this).toggleClass('-active');
});